import './SMSPhonePreview.scss';
import React, { useMemo } from 'react';
import { ReactComponent as PhoneNotch } from 'assets/icons/icon-phone-notch.svg';
import type { TSMSPreviewData } from 'components/FlowBuilder/FlowSidePanels/types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import ErrorIcon from 'assets/icons/icon-error-triangle.svg';
import { processTemplateContent } from '../../shared/utils/emailSMS/template-preview.utils';

const MAIN_CLASS = `sms-phone-preview`;
const CLASSES = {
  HEADER: `${MAIN_CLASS}__header`,
  CONTENT: `${MAIN_CLASS}__content`,
  SMS: `${MAIN_CLASS}__content__sms`,
  SMS_HEADER: `${MAIN_CLASS}__content__sms__header`,
  SMS_SENDER_NUMBER: `${MAIN_CLASS}__content__sms__header__sender-number`,
  SMS_TIME: `${MAIN_CLASS}__content__sms__header__time`,
  SMS_CONTENT: `${MAIN_CLASS}__content__sms__content`,
  SMS_TITLE: `${MAIN_CLASS}__content__sms__content__title`,
  SMS_BODY: `${MAIN_CLASS}__content__sms__content__body`,
  FOOTER: `${MAIN_CLASS}__footer`,
  MAPPED_VALUE: `${MAIN_CLASS}__mapped-value`,
  ERROR: `${MAIN_CLASS}__error`,
};

interface SMSPhonePreviewProps {
  previewData: TSMSPreviewData;
  isLoading?: boolean;
}

function SMSPhonePreview({ previewData, isLoading }: SMSPhonePreviewProps) {
  const smsBodyHtml = useMemo(() => {
    if (isLoading || !previewData.body) return '';

    return processTemplateContent({
      content: previewData.body,
      data: previewData.data,
      errorIconSrc: ErrorIcon,
      mappedValueClass: CLASSES.MAPPED_VALUE,
      errorClass: 'error',
      isHtmlContent: false,
    });
  }, [previewData.body, previewData.data, isLoading]);

  return (
    <div className={MAIN_CLASS}>
      <div className={CLASSES.HEADER}>
        <PhoneNotch />
      </div>
      <div className={CLASSES.CONTENT}>
        <div className={CLASSES.SMS}>
          {isLoading ? (
            <Skeleton width="100%" height={125} />
          ) : (
            <>
              <div className={CLASSES.SMS_HEADER}>
                <div className={CLASSES.SMS_SENDER_NUMBER}>{previewData.data?.sender_number || 'Unknown Sender'}</div>
                <div className={CLASSES.SMS_TIME}>now</div>
              </div>
              <div className={CLASSES.SMS_CONTENT}>
                <div className={CLASSES.SMS_TITLE}>{previewData.title}</div>
                <div className={CLASSES.SMS_BODY} dangerouslySetInnerHTML={{ __html: smsBodyHtml }} />
              </div>
            </>
          )}
        </div>
      </div>
      <div className={CLASSES.FOOTER} />
    </div>
  );
}

export default SMSPhonePreview;
